import React from 'react'

export default (props) => {
  return <i className={`ion-${props.name}`} />
}



// WEBPACK FOOTER //
// ./app/components/Icon.js